import { createMuiTheme, responsiveFontSizes, ThemeProvider } from "@material-ui/core/styles";
import { createContext, useContext, useEffect, useState } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";

export const light = responsiveFontSizes(createMuiTheme({
  props: {
    MuiTooltip: {
      arrow: true,
      style: {
        pointerEvents: "all",
      },
    },
    MuiButton: {
      disableFocusRipple: true,
    },
    MuiDivider: {
      style: {
        marginTop: 16,
        marginBottom: 16,
      },
    },
  },
  typography: {
    allVariants: {
      fontFamily: "Rubik",
    },
    button: {
      textTransform: "capitalize",
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 4,
  },
  palette: {
    type: "light",
    primary: {
      main: "#fb2dfa",
    },
    secondary: {
      main: "#903ebc",
    },
    text: {
      primary: "#ffffff",
    },
    background: {
      default: "#f5f5f5",
      paper: "#fff",
    },
    common: {
      black: "#0F100B",
      white: "#FCFCFC",
    },
  },
}));

export const dark = responsiveFontSizes(createMuiTheme({
  props: {
    MuiTooltip: {
      arrow: true,
      style: {
        pointerEvents: "all",
      },
    },
    MuiButton: {
      disableFocusRipple: true,
    },
    MuiDivider: {
      style: {
        marginTop: 16,
        marginBottom: 16,
      },
    },
  },
  typography: {
    allVariants: {
      fontFamily: "Rubik",
    },
    button: {
      textTransform: "capitalize",
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 4,
  },
  palette: {
    type: "dark",
    primary: {
      main: "#B588F7",
      contrastText: "#fff",
    },
    secondary: {
      main: "#78909c",
      contrastText: "#fff",
    },
    accent: {
      main: "#2699F9",
    },
    background: {
      paper: "#303540",
      default: "#20232C",
    },
    common: {
      black: "#191919",
      white: "#FCFCFC",
    },
  },
}));

export const ThemeSelectorContext = createContext({
  theme: "",
});

export const useThemeSelector = () => useContext(ThemeSelectorContext);

export const withTheme = (Component) => (props) => {
  const [t, setT] = useState("dark");
  const toggleTheme = () => {
    const newTheme = t === "light" ? "dark" : "light";
    localStorage.setItem("theme", newTheme);
    setT(newTheme);
  };

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      setT(savedTheme);
    }
  }, []);
  const theme = t === "light" ? light : dark;
  
  return (
    <ThemeSelectorContext.Provider value={toggleTheme}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Component {...props} />
      </ThemeProvider>
    </ThemeSelectorContext.Provider>
  );
};
